import { SelectOption } from "./SelectOption";

export const menuSortFavorite: SelectOption[] = [
  {
    id: 1,
    name: "Terbaru",
    note: "",
  },
  {
    id: 2,
    name: "A-Z",
    note: "asc",
  },
];

export const menuSortProduct: SelectOption[] = [
  {
    id: 1,
    name: "Termurah",
    nama: "price",
    note: "murah",
  },
  {
    id: 2,
    name: "Termahal",
    nama: "price",
    note: "mahal",
  },
  {
    id: 3,
    name: "A-Z",
    nama: "sort",
    note: "asc",
  },
  {
    id: 4,
    name: "Z-A",
    nama: "sort",
    note: "desc",
  },
  {
    id: 5,
    name: "Terbaru",
    nama: "sort",
    note: "latest",
  },
];

export const menuSortProductSimple: SelectOption[] = [
  {
    id: 1,
    name: "A-Z",
    nama: "sort",
    note: "asc",
  },
  {
    id: 2,
    name: "Z-A",
    nama: "sort",
    note: "desc",
  },
  {
    id: 3,
    name: "Terbaru",
    nama: "sort",
    note: "",
  },
];

export const menuSortSupplierList: SelectOption[] = [
  {
    id: 1,
    name: "A-Z",
    note: "asc",
  },
  {
    id: 2,
    name: "Z-A",
    note: "desc",
  },
  {
    id: 3,
    name: "Baru Mendaftar",
    note: "",
  },
];
